import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import PageWrapper from "../PageWrapper";
import { PrimaryHeader } from "../../components/headings";
import Bold from "../../components/bold/bold";
import { PaddedPaper } from "../../components/paper";
import ContentWrapper from "../../components/contentWrapper";
import { TabLayout } from "../../components/tabLayout";
import { ManageRepaymentSheet } from "./components";
import { Wrapper } from "./manageRepayments.styles";
import { useAccountIdRouter } from "./hooks";
import { ManageRepaymentsRouter } from "./manageRepaymentsRouter";

export const ManageRepayments = () => {
  const { clientData } = useSelector((state) => state.Client);
  const [accountId, swapAccount] = useAccountIdRouter();

  const { openAccounts } = clientData;

  return (
    <PageWrapper>
      {openAccounts.length === 0 ? <Redirect to="/dashboard" /> :
        <Wrapper>
          <PaddedPaper>
            <ContentWrapper className="page-wrapper temp-wrapper-fix">
              <PrimaryHeader>
                Manage Your <Bold>Repayments</Bold>
              </PrimaryHeader>
              <TabLayout setActiveTabId={swapAccount} activeTabId={accountId}>
                {openAccounts.map((account) => (
                  <ManageRepaymentSheet key={account.accountNumber} {...account} />
                ))}
              </TabLayout>
              <ManageRepaymentsRouter accountId={accountId} />
            </ContentWrapper>
          </PaddedPaper>
        </Wrapper>}
    </PageWrapper>
  );
};
